import ControlAmount from './ControlAmount'

export default ControlAmount
